import BaseApiServiceV2 from "./BaseApiServiceV2";

class EmailService extends BaseApiServiceV2 {
    /**
     * @param {String} name
     * @returns Promise<Object>
     * @memberof EmailService
     */
    async verifyEmail(name: string) {
        const res: any = await this.apiGet(`/email/verify/${name}`);
        return res?.data ?? res;
    }
}
export default new EmailService();
